import { makeStyles } from '@material-ui/core';

// Границы ячеек без наложений: каждая ячейка рисует линию только снизу и справа,
// а внешние верх/лево даёт сам <table>. Внутренняя линия между ячейками всегда одна.
// Каскад `& .MuiTableCell-root` покрывает и вложенные (помесячные) таблицы.
// Ячейки-обёртки colSpan под Collapse отключают границы инлайном (border: none).
export const useBorderedTableStyles = makeStyles((theme) => ({
  table: {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderLeft: `1px solid ${theme.palette.divider}`,

    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  },
}));
